import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  loading: boolean = false;

  constructor(
    public loadingController: LoadingController,
  ) { }

  async show(duration?) {
    if (this.loading == false) {
      if (duration == 'loop') {
        duration = null;
      } else {
        duration = 2000;
      }

      this.loading = true;
      const loading = await this.loadingController.create({
        cssClass: 'loadingNoBg',
        spinner: "circular",
        duration: duration,
        backdropDismiss: true,
      });

      await loading.present();
    }
  }

  async dismiss() {
    if (this.loading == true) {
      setTimeout(() => {

        this.loadingController.dismiss();

        this.loading = false;
      }, 500);
    }
  }
}
